import { z } from "zod";

import { BRAND_MARKUP } from "../../constants";
import { attachment } from "../shared";
import { defineModel } from "../types";

// ElevenLabs STT pricing: ~$0.40 per hour of audio
const COST_PER_SECOND_MICRODOLLARS = (0.4 / 3600) * 1_000_000;

const elevenlabsSTTParams = z
  .object({
    languageCode: z.string().optional(),
    attachments: z.array(attachment).optional(),
  })
  .strip();

export const elevenlabsSTT = defineModel({
  key: "elevenlabs-stt",
  stepType: "stt",
  spec: {
    label: "ElevenLabs",
    description: "High-quality speech-to-text with word-level timestamps",
    icon: "elevenlabs-icon.svg",
    tags: ["elevenlabs"],
    features: { attachments: true } as const,
    options: {
      attachments: [
        {
          type: "audio",
          label: "Audio File",
          slot: "audio",
          required: true,
          allowedFormats: [
            "audio/wav",
            "audio/mp3",
            "audio/mpeg",
            "audio/m4a",
            "audio/ogg",
          ],
        },
      ],
    },
    params: elevenlabsSTTParams,
  },
  providers: [
    {
      provider: "elevenlabs",
      modelId: "elevenlabs-stt",
      estimateCost(_params) {
        // Default estimate for 60 seconds of audio
        const estimatedDurationSeconds = 60;
        return Math.round(
          estimatedDurationSeconds *
            COST_PER_SECOND_MICRODOLLARS *
            (1 + BRAND_MARKUP),
        );
      },
      toPayload(params) {
        return {
          languageCode: params.languageCode,
        };
      },
    },
  ],
});
